import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppRoutes } from '@helpers/app-routes';

const STORAGE_KEY = 'navigation_history';

@Injectable({ providedIn: 'root' })
export class HistoryService {
  readonly #router = inject(Router);
  #history: string[] = this.#readStorage();
  #isNavigatingBack = false;

  constructor() {
    this.#router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.#isNavigatingBack) {
          this.#isNavigatingBack = false;
          return;
        }
        if (this.#history[this.#history.length - 1] === event.urlAfterRedirects) {
          return;
        }
        this.#history.push(event.urlAfterRedirects);
        this.#writeStorage();
      });
  }

  pushPath(url: string): void {
    if (this.#history[this.#history.length - 1] === url) return;
    this.#history.push(url);
    this.#writeStorage();
  }

  back(): void {
    this.#history.pop();
    const previousUrl = this.#history[this.#history.length - 1];
    this.#writeStorage();

    if (previousUrl) {
      this.#isNavigatingBack = true;
      this.#router.navigateByUrl(previousUrl);
    } else {
      this.#router.navigate([AppRoutes.scanPage]);
    }
  }

  #readStorage(): string[] {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as string[]) : [];
    } catch {
      return [];
    }
  }

  #writeStorage(): void {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.#history));
  }
}
